export const LINE_ITEM_QUANTITY_LIMIT = 999999;
export const LINE_ITEM_ID_URL_SEARCH_PARAM = "lineItemId";
export const CONFIGURATION_URL_SEARCH_PARAM = "configuration";
